import React from 'react';

import { css, cx } from '@emotion/css';
import { Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { useStyles } from '@/hooks/useStyles.ts';
import { Message } from '@/models/MessagingModel.ts';
import { Theme } from '@/theme/CreateTheme.ts';

export type MessageTextProps = {
  message: Message;
  className?: string;
};

export const MessageText: React.FC<MessageTextProps> = ({
  message,
  className,
}) => {
  const { t } = useTranslation();
  const styles = useStyles(makeStyles);

  const text = message.deleted ? t('messaging.deleted') : message.text;

  if (!text) {
    return null;
  }

  return (
    <Typography
      variant="body"
      className={cx(styles.container, className, {
        [styles.deleted]: message.deleted,
      })}
    >
      {text}
    </Typography>
  );
};

const makeStyles = (theme: Theme) => ({
  container: css({
    whiteSpace: 'pre-wrap',
    maxWidth: '100%',
  }),
  deleted: css({
    fontStyle: 'italic',
    color: theme.palette.text.disabled,
  }),
  deletedMessage: css({
    fontStyle: 'italic',
    textDecoration: 'line-through',
    color: theme.palette.text.disabled,
  }),
});
